import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { ChallengeType } from 'src/models/Challenge';
import { Coach } from 'src/models/Coach';
import { Tag } from 'src/models/Tag';
import { FilterTrait } from 'src/models/SessionFilters';
import { ChallengesService } from 'src/services';

const optionsLimit = 500;

export const useChallengeFilterOptions = (challengeType: ChallengeType) => {
  const { data } = useQuery(
    ['challengeFilterOptions', challengeType],
    () => ChallengesService.getFilterOptions(challengeType, optionsLimit),
    { staleTime: Infinity },
  );

  return useMemo(() => {
    const challenges = Array.isArray(data) ? data : [];
    const tagMap = new Map<string, Tag>();
    const coachMap = new Map<string, Coach>();

    for (const challenge of challenges) {
      for (const item of challenge.tag) {
        tagMap.set(item.id, Tag.fromDto({
          id: item.id as Tag['id'],
          name: item.name,
          description: null,
          trait: FilterTrait.Tag,
        }));
      }
      for (const item of challenge.coach) {
        coachMap.set(item.id, item);
      }
    }

    const tag = [...tagMap.values()].sort((a, b) => a.name.localeCompare(b.name));
    const coach = [...coachMap.values()].sort((a, b) => a.name.localeCompare(b.name));

    return { tag, coach };
  }, [data]);
};
